"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importStar(require("../Themes/styled-components"));
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  margin-top: ", ";\n  margin-bottom: ", ";\n  width: 100%;\n"], ["\n  display: flex;\n  margin-top: ", ";\n  margin-bottom: ", ";\n  width: 100%;\n"])), polished_1.rem(10), polished_1.rem(18));
var StyledLine = styled_components_1.default('hr')(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: block;\n  height: ", ";\n  border: 0;\n  border-top: ", " solid\n    ", ";\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n  ", "\n"], ["\n  display: block;\n  height: ", ";\n  border: 0;\n  border-top: ", " solid\n    ",
    ";\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n  ",
    "\n"])), polished_1.rem(1), polished_1.rem(1), function (_a) {
    var primary = _a.primary, theme = _a.theme;
    return primary ? theme.color.primary : theme.separatorColor;
}, function (_a) {
    var primary = _a.primary;
    return primary && styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      flex-shrink: 0;\n      min-width: ", ";\n      width: 12%;\n    "], ["\n      flex-shrink: 0;\n      min-width: ", ";\n      width: 12%;\n    "])), polished_1.rem(75));
});
var Separator = /** @class */ (function (_super) {
    tslib_1.__extends(Separator, _super);
    function Separator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Separator.prototype.render = function () {
        var className = this.props.className;
        return (React.createElement(Wrapper, { className: className },
            React.createElement(StyledLine, { primary: true }),
            React.createElement(StyledLine, null)));
    };
    return Separator;
}(React.PureComponent));
exports.default = Separator;
var templateObject_1, templateObject_2, templateObject_3;
